@if(customContent) {
  <ng-content></ng-content>
} @else if(tooltipText) {
  @if(isDisabled) {
    <i class="disabled" [class]="iconClass"></i>
  } @else {
    <i
      container="body"
      [class]="iconClass"
      [tooltipClass]="widthAuto ? 'tooltip-info width-auto' : 'tooltip-info'"
      [placement]="placement"
      [ngbTooltip]="tooltipText"
      (click)="onClick()"
    ></i>
  }
}
